import { cn } from "@/utilities/cn";
import { A } from "@solidjs/router";
import { Show } from "solid-js";

export const Cards = (props: { collapsed?: boolean }) => {
  return (
    <div class="grid grid-cols-1 gap-4">
      <A
        href='/items'
        class="group bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 hover:border-blue-500 dark:hover:border-blue-500 transition-colors"
        title="Items"
      >
        <div class={cn(
          "flex items-center",
          props.collapsed ? "justify-center p-4" : "justify-between p-6"
        )}>
          <Show when={!props.collapsed}>
            <h2 class="text-lg font-semibold group-hover:text-blue-500">Items</h2>
          </Show>
          <span class="text-2xl">🗂️</span>
        </div>
        <Show when={!props.collapsed}>
          <p class="px-6 pb-6 text-sm text-gray-600 dark:text-gray-400">
            Manage everything
          </p>
        </Show>
      </A>

      <A
        href='/media'
        class="group bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 hover:border-blue-500 dark:hover:border-blue-500 transition-colors"
        title="Media"
      >
        <div class={cn(
          "flex items-center",
          props.collapsed ? "justify-center p-4" : "justify-between p-6"
        )}>
          <Show when={!props.collapsed}>
            <h2 class="text-lg font-semibold group-hover:text-blue-500">Media</h2>
          </Show>
          <span class="text-2xl">📷</span>
        </div>
        <Show when={!props.collapsed}>
          <p class="px-6 pb-6 text-sm text-gray-600 dark:text-gray-400">
            Manage your media
          </p>
        </Show>
      </A>

      <A
        href='/tables'
        class="group bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 hover:border-blue-500 dark:hover:border-blue-500 transition-colors"
        title="Tables"
      >
        <div class={cn(
          "flex items-center",
          props.collapsed ? "justify-center p-4" : "justify-between p-6"
        )}>
          <Show when={!props.collapsed}>
            <h2 class="text-lg font-semibold group-hover:text-blue-500">Tables</h2>
          </Show>
          <span class="text-2xl">📊</span>
        </div>
        <Show when={!props.collapsed}>
          <p class="px-6 pb-6 text-sm text-gray-600 dark:text-gray-400">
            Manage your tables
          </p>
        </Show>
      </A>
    </div>
  );
};
